import { render, staticRenderFns } from "./SelectInputTUI.vue?vue&type=template&id=610d6404&scoped=true&"
import script from "./SelectInputTUI.vue?vue&type=script&lang=js&"
export * from "./SelectInputTUI.vue?vue&type=script&lang=js&"
import style0 from "./SelectInputTUI.vue?vue&type=style&index=0&id=610d6404&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610d6404",
  null
  
)

export default component.exports